/* eslint-disable jsx-a11y/anchor-is-valid */

// Core imports
import { Col, Layout, Row } from 'antd';
import { Link } from 'react-router-dom';
import { NAV_FAQ, NAV_DONATE, NAV_JOIN_US, NAV_LEGAL_NOTICE, NAV_ABOUT, NAV_PRIVACY_POLICY, NAV_BLOG, SUPPORT_EMAIL, FACEBOOK_URL, DEVELOPER_NAME, DEVELOPER_URL } from '../../constants';
import { FacebookIcon } from '../Icons/FacebookIcon';

// Constant declarations
const { Footer } = Layout;

const GlobalFooter = () => {
  return (
    <Footer className="position-relative bg-black-20 bg-dark-100 pt-sm-64 pt-120 pb-24 overflow-hidden">
      <div className="landing-footer-circle bg-color-black-60 bg-color-dark-40"></div>

      <div className="landing-container">
        <Row justify="space-between" className="mb-sm-64 mb-120">
          <Col lg={8} md={16} span={24}>
            <p className="h5 font-weight-500 text-color-black-80 text-color-dark-30 mb-32">
              Disclaimer: The information contained in this website is provided as a service to the Internet community, and does not constitute legal, medical, or therapeutic advice.
            </p>

            <Link
              to={NAV_LEGAL_NOTICE}
              className="ant-btn bg-black-100 text-color-black-0"
            >
              Read legal notice
            </Link>
          </Col>

          <Col lg={14} span={24} className="mt-md-64">
            <Row>
              <Col flex="1 0 0">
                <a href={NAV_FAQ} className="d-block h5 font-weight-400 text-color-black-80 text-color-dark-30">FAQ</a>
                <a href={NAV_PRIVACY_POLICY} className="d-block h5 font-weight-400 text-color-black-80 text-color-dark-30 mt-16">Privacy</a>
                <a href={NAV_LEGAL_NOTICE} className="d-block h5 font-weight-400 text-color-black-80 text-color-dark-30 mt-16">Legal Notice</a>
              </Col>

              <Col flex="1 0 0">
                <a href={NAV_ABOUT} className="d-block h5 font-weight-400 text-color-black-80 text-color-dark-30">About</a>
                <a href={NAV_JOIN_US} className="d-block h5 font-weight-400 text-color-black-80 text-color-dark-30 mt-16">Get Involved</a>
                <a href={NAV_DONATE} className="d-block h5 font-weight-400 text-color-black-80 text-color-dark-30 mt-16">Donate</a>
                <a href={NAV_BLOG} className="d-block h5 font-weight-400 text-color-black-80 text-color-dark-30 mt-16">Blog</a>
              </Col>

              <Col flex="0 0 260px" className="mt-sm-32">
                <p className="h5 font-weight-400 text-color-black-80 text-color-dark-30">
                  Feel free to get in touch <br />
                  via email or social media.
                </p>

                <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row align="middle" justify="space-between" className="landing-footer-copyright border-top-1 border-color-dark-80 pt-24 mt-24">
          <Col>
            <p className="p1-body mb-sm-16 mb-0">
              NDE Archive © 2026, All Rights Reserved. Developed by{' '}
              <a
                href={DEVELOPER_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-color-primary-1"
              >
                {DEVELOPER_NAME}
              </a>
            </p>
          </Col>

          <Col>
            <Row align="middle">
              <Col className="ml-18">
                <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer">
                  <FacebookIcon size={16} className="fill-primary-1" />
                </a>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </Footer>
  );
};

export default GlobalFooter;
